import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMediaQuery } from 'types/interfaces';

export const initialState = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xlg: false
} as IMediaQuery;

const mediaQuerySlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setMediaQuery(state, action: PayloadAction<IMediaQuery>) {
      if (JSON.stringify(action.payload) !== JSON.stringify(state)) {
        state = { ...state, ...action.payload };
      }
      return state;
    },
    setInnerHeight(state, action: PayloadAction<string>) {
      if (JSON.stringify(action.payload) !== JSON.stringify(state)) {
        state.innerHeight = action.payload;
      }
      return state;
    }
  }
});

export const mediaQueryActions = mediaQuerySlice.actions;
export default mediaQuerySlice.reducer;
